// Mutation hook - soft disconnect WhatsApp dla skrzynki biezacego handlowca.
// POST /api/ui/sales-crm/whatsapp/embedded-signup/disconnect
// Faza 7 - best-effort unsubscribe na Meta + clear lokalnych pol.

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import { getWhatsappEmbeddedSignupConfigQueryKey } from 'api/endpoints/useGetWhatsappEmbeddedSignupConfig';

export interface IPostDisconnectWhatsappResponse {
  data?: {
    success?: boolean;
  };
  message?: string;
  status?: string;
}

const postDisconnectWhatsapp = (): Promise<IPostDisconnectWhatsappResponse> =>
  axios.post('/sales-crm/whatsapp/embedded-signup/disconnect');

export const usePostDisconnectWhatsapp = (
  options?: UseMutationOptions<IPostDisconnectWhatsappResponse, IError, void>
) => {
  const queryClient = useQueryClient();
  return useMutation<IPostDisconnectWhatsappResponse, IError, void>(postDisconnectWhatsapp, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(getWhatsappEmbeddedSignupConfigQueryKey);
      options?.onSuccess?.(data, variables, context);
    }
  });
};
